import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PodValidationWidgetCarrierManagerData} from './pod-validation-widget-carrier-manager-data.model';
import {HttpUtils} from '../../../shared/http-utils';
import {URL_BASE} from '../../constants';
import {map} from 'rxjs/operators';
import {PodValidationWidgetChepManagerData} from './pod-validation-widget-chep-manager-data.model';

@Injectable()
export class WidgetsService {

  private WIDGETS_URI = 'widgets';
  private PODS_VALIDATION_URI = 'pods-validation';

  constructor(private http: HttpClient) {}

  public getPodValidationCarrierManagerWidgetData(forceRefresh?: boolean): Observable<PodValidationWidgetCarrierManagerData> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/${this.WIDGETS_URI}/${this.PODS_VALIDATION_URI}/carrier-manager`;
    const params = forceRefresh ? { forceRefresh: 'true' } : {};

    return this.http.get(url, { headers, params })
      .pipe(map(result => PodValidationWidgetCarrierManagerData.fromDto(result)))
  }

  public getPodValidationChepManagerData(forceRefresh?: boolean): Observable<PodValidationWidgetChepManagerData> {
    const headers = HttpUtils.createHeaders();
    const url = `${URL_BASE}/api/${this.WIDGETS_URI}/${this.PODS_VALIDATION_URI}/chep-manager`;
    const params = forceRefresh ? { forceRefresh: 'true' } : {};

    return this.http.get(url, { headers, params })
      .pipe(map((result: any[]) => PodValidationWidgetChepManagerData.fromDto(result)))
  }
}
